import {
  AnimatePresence as _AnimatePresence,
  AnimatePresenceProps,
} from "framer-motion"
import { FCC } from "../reactHelpers/types"

export const AnimatePresence = _AnimatePresence as FCC<AnimatePresenceProps>
